module.exports = __webpack_public_path__ + "static/media/bankett.dc20836e.jpg";